import { gql } from '@apollo/client';

export default gql`
  query getLoanout {
    getLoanout {
      taxId
      name
      type
      address
      city
      state
      zipCode
      w9
      loi
      createdAt
      isValid
    }
  }
`;
